module.exports = __webpack_public_path__ + "static/media/tommy5.72fe3138.svg";